import { useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/App";

const LINKS = [
  { id: "diensten", label: "Diensten" },
  { id: "hoe-het-werkt", label: "Hoe het werkt" },
  { id: "faq", label: "FAQ" },
  { id: "contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 bg-ink/80 backdrop-blur-xl" data-testid="site-header">
      <div className="mx-auto flex h-[72px] max-w-7xl items-center justify-between px-5 lg:px-8">
        <button onClick={() => window.__lenis?.scrollTo(0, { duration: 1.2 })} data-testid="header-logo-btn" aria-label="Naar boven">
          <Logo height={52} />
        </button>
        <nav className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`nav-${l.id}-link`}
              className="font-mono text-xs uppercase tracking-[0.2em] text-muted2 transition-colors duration-200 hover:text-safety"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <button
            onClick={() => go("offerte")}
            data-testid="header-quote-btn"
            className="group hidden items-center gap-2 bg-brand px-5 py-2.5 font-display text-base font-bold uppercase tracking-wide text-ink transition-colors duration-200 hover:bg-safety sm:flex"
          >
            Offerte aanvragen
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <button onClick={() => setOpen(!open)} className="text-paper lg:hidden" data-testid="mobile-menu-btn" aria-label="Menu">
            {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="border-t border-white/10 bg-ink px-5 py-6 lg:hidden" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              data-testid={`mobile-nav-${l.id}-link`}
              className="block w-full py-3 text-left font-display text-2xl font-bold uppercase text-paper"
            >
              {l.label}
            </button>
          ))}
          <button onClick={() => go("offerte")} data-testid="mobile-quote-btn" className="mt-3 w-full bg-brand px-5 py-3 font-display text-lg font-bold uppercase text-ink">
            Offerte aanvragen
          </button>
        </div>
      )}
    </header>
  );
}
